

























































































































































































































































import axios from 'axios';
import { get, remove } from 'lodash';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import { Page, User } from '../../../types/GlobalTypes';
import CoImage from '../../Atoms/co-image/CoImage.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoHeadline from '../../Atoms/co-headline/CoHeadline.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import CoDate from '../co-date/CoDate.vue';
import CoPill from '../../Atoms/co-pill/CoPill.vue';
import CoLink from '../../Atoms/co-link/CoLink.vue';
import EventBus from '../../../eventBus';
import CoConfirmation from '../co-confirmation/CoConfirmation.vue';
import CoPeople from '../co-people/CoPeople.vue';

export default {
    components: {
        CoIcon,
        CoSkeleton,
        CoHeadline,
        CoButton,
        CoText,
        CoImage,
        CoThumbnail,
        CoDate,
        CoPill,
        CoLink,
        CoConfirmation,
        CoPeople,
    },
    name: 'CoPage',
    props: {
        page: {
            type: Object as () => Page,
            default: () => ({}),
        },
        variant: {
            type: String,
            validator: (value: string) => ['default', 'micro', 'list', 'full'].includes(value),
            default: 'default',
            required: false,
        },
        loading: {
            type: Boolean,
            default: false,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        },
        link: {
            type: Boolean,
            required: false,
            default: true,
        },
        forceMobileLayout: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            meLocal: this.me || {
                ...get(this.$store, 'state.me', {}),
                ...get(this.$store, 'state.me.Profile', {}),
            },
            isAdmin: false,
        };
    },
    computed: {
        followers: {
            get() {
                return get(this.page, 'FollowedBy', []);
            },
            set(value) {
                this.page = {
                    ...this.page,
                    FollowedBy: value,
                };
            },
        },
        isMine() {
            return this.page?.Contributors?.some((owner) => owner?.ID === this.meLocal?.ID);
        },
        isPaid() {
            return this.page?.Paid;
        },
        amIfollowing() {
            const meID = this.meLocal?.ID;
            return this.page?.FollowedBy?.includes(meID);
        },
        getImage() {
            return get(this.page, 'Images[0].ImageURL', null);
        },
        // Reuse the existing mobile branch of the full layout without duplicating the template.
        useMobileFullLayout() {
            return this.variant === 'full' && this.forceMobileLayout;
        },
    },
    // watch: {
    //     page: {
    //         handler(newVal) {
    //             let meID = get(this.meLocal, 'ID', '');

    //             // this.isMine = get(newVal, 'Owners', []).some((owner) => owner.ID === meID);
    //             // this.amIfollowing = get(newVal, 'FollowedBy', []).includes(meID);

    //         },
    //         deep: true,
    //     },
    // },
    mounted() {
        // this.isMine = this.meLocal && get(this.page, 'AuthorID', null) === this.meLocal.ID;
        // this.amIfollowing = this.meLocal && this.page.FollowedBy && this.page.FollowedBy.includes(this.meLocal.ID);
        this.isAdmin = get(this.$store, 'state.me.Permissions', []).includes('space_admin');
    },
    methods: {
        get(object, path, defaultValue?: string) {
            return get(object, path, defaultValue);
        },
        desktopOnlyClass(display = 'block') {
            return this.useMobileFullLayout ? 'd-none' : `d-none d-md-${display}`;
        },
        mobileOnlyClass(display = 'block') {
            return this.useMobileFullLayout ? `d-${display}` : `d-${display} d-md-none`;
        },
        followPage() {
            if (!this.meLocal) return;
            this.$emit('follow', this.page);
            this.followers.length > 0 ? this.followers.unshift(this.meLocal.ID) : (this.followers = [this.meLocal.ID]);
            axios({
                method: 'POST',
                url: '/project/follow',
                data: {
                    ProjectID: this.page.ID,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            }).catch((error) => {
                this.page.FollowedBy.pop();
                EventBus.$emit('ERROR', {
                    Message: 'Project follow failed',
                    Details: null,
                });
            });
        },
    },
};
